// extracted by mini-css-extract-plugin
export default {"container":"ContentEditable__container___rMlPH"};